/** Compact, human-readable duration: `1h 1m`, `2m 30s`, or `45s`. Negative or
 * non-integer inputs are clamped and rounded, so a seconds average never renders
 * a fractional or negative value. Shared across the Overview catalog and the Ask
 * IA tiles so a `duration_seconds` metric reads identically on every surface. */
export const formatDurationSeconds = (totalSeconds: number): string => {
    const s = Math.max(0, Math.round(totalSeconds));
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
};
